import { TImageSize } from './types';

export const IMAGE_SIZE: TImageSize = {
  phone: 160,
  tablet: 160,
  desktop: 232,
};
